import React from "react";
import { Button, Modal, ModalBody } from "react-bootstrap";
import { loadingWrapper } from "../../../utils/loadingWrapper";
import useTicket from "../../../hooks/useTicket";
import { toast } from "react-toastify";
const MAX_FILE_SIZE = 3 * 1024 * 1024;
const MAX_ATTACHMENT = 3;

class CreateTicket extends React.Component {
    state = {
        newTicket: {
            categoria: "",
            oggetto: "",
            descrizione: "",
        },
        attachments: [],
        temporaryFile: { file: null, value: "" },
        fileSizeError: false,
    };

    newTicketIsInvalid = () => {
        const { newTicket } = this.state;
        const inputValidator = {
            categoria: newTicket.categoria !== "" && newTicket.categoria.trim().length > 0,
            oggetto: newTicket.oggetto !== "" && newTicket.oggetto.trim().length > 0,
            descrizione: newTicket.descrizione !== "" && newTicket.descrizione.trim().length > 0,
        };

        return !(inputValidator.categoria && inputValidator.oggetto && inputValidator.descrizione);
    };

    newTicketInputHandler = (event) => {
        const { name, value } = event.target;
        this.setState((prevState) => ({
            ...prevState,
            newTicket: { ...prevState.newTicket, [name]: value },
        }));
    };

    handleFileChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        if (file.size > MAX_FILE_SIZE) {
            this.setState({ temporaryFile: { file: null, value: "" }, fileSizeError: true });
            return;
        }

        this.setState({
            temporaryFile: { file, value: event.target.value },
            fileSizeError: false,
        });
    };

    addAttachment = () => {
        const { attachments, temporaryFile } = this.state;
        if (!temporaryFile.file || attachments.length >= MAX_ATTACHMENT) return;

        this.setState((prevState) => ({
            ...prevState,
            attachments: [...prevState.attachments, prevState.temporaryFile.file],
            temporaryFile: { file: null, value: "" },
        }));
    };

    removeAttachment = (index) => {
        this.setState((prevState) => ({
            ...prevState,
            attachments: prevState.attachments.filter((_, i) => i !== index),
        }));
    };

    showAttachment = (file) => {
        window.open(URL.createObjectURL(file), "_blank");
    };

    closeModal = () => {
        const { onClose } = this.props;
        if (onClose) {
            onClose();
        }

        this.setState({
            newTicket: { categoria: "", oggetto: "", descrizione: "" },
            attachments: [],
            temporaryFile: { file: null, value: "" },
            fileSizeError: false,
        });
    };

    confirmCreateTicket = async () => {
        const { createTicket, saveAttachment, onSuccess } = this.props;
        const { newTicket, attachments } = this.state;

        let filesToUpload = JSON.parse(JSON.stringify(attachments));

        createTicket(
            {
                oggetto: newTicket.oggetto,
                descrizione: newTicket.descrizione,
                categoria: newTicket.categoria,
            },
        async (response) =>{
                
                    let idTicket = response.id

                    if (attachments.length > 0) {
                        let successfulFile = 0 
                        await Promise.all(
                            attachments.map(file => {
                                return new Promise((resolve) => {
                                    saveAttachment(
                                        idTicket,
                                        file,
                                        () => {
                                            
                                            successfulFile++
                                            
                                            resolve(true)
                                        },
                                        () => {
                                            
                                            resolve(false)
                                        }

                                    )

                                })

                            })

                        )
                        

                        if (successfulFile === attachments.length){
                            toast.success("Tutti gli allegati sono stati caricati correttamente")
                        } else if(successfulFile === 0) {
                        
                            toast.error("Errore nel caricamento degli allegati")
                        } else{
                            toast.warning(`${successfulFile} su ${attachments.length} caricati con successo`)
                        }
                    }

                    onSuccess();


                    
                    toast.success("Ticket creato con successo")
                    this.closeModal();
            },
            () => {
                toast.error("Errore nella creazione del ticket");
            }
        );
    };

    render() {
        const { show, loadingTicket } = this.props;
        const { newTicket, attachments, temporaryFile, fileSizeError } = this.state;

        return (
            <Modal show={show}>
                <Modal.Header closeButton onHide={this.closeModal}>
                    <Modal.Title className="d-flex justify-content-between w-100">
                        <p className="m-0">Crea Ticket</p>
                    </Modal.Title>
                </Modal.Header>
                <ModalBody>
                    <div>
                        <fieldset className='detail-fieldset flex-column gap-2'>
                        <legend className='detail-legend'>Dettagli ticket</legend>
                          <div>
                            <p className='m-0'>Categoria*</p>
                            <select className='form-select' name="categoria" value={newTicket.categoria} onChange={this.newTicketInputHandler}>
                                <option value="">Seleziona una categoria</option>
                                <option value="anomalia">Anomalia</option>
                                <option value="nuova-richiesta">Nuova richiesta</option>
                            </select>
                          </div>
                          <div>
                            
                            <p className='m-0'>Oggetto*</p>
                            <input className='form-control' placeholder=""  maxLength={60} name='oggetto' onChange={this.newTicketInputHandler} type='text'></input>
                    
                        
                            <p className='m-0'>Descrizione*</p>
                            <textarea className='form-control' placeholder=""  maxLength={120} name='descrizione' onChange={this.newTicketInputHandler} type='text'></textarea>
                            
                            
                          </div>
                        </fieldset>
                        <fieldset className='detail-fieldset flex-column gap-2 mt-3'>
                            <legend className='detail-legend'>Allegati</legend>
                            <div className="d-flex gap-2">
                                <input
                                    className="form-control"
                                    type="file"
                                    accept=".png, .jpg, .jpeg, .pdf"
                                    value={temporaryFile.value}
                                    multiple
                                    disabled={attachments.length >= MAX_ATTACHMENT}
                                    onChange={this.handleFileChange}
                                ></input>
                                <Button
                                    variant="primary"
                                    onClick={this.addAttachment}
                                    disabled={!temporaryFile.file || attachments.length >= MAX_ATTACHMENT}
                                >
                                    <i className="fas fa-plus" color="white" />
                                </Button>                       
                            </div>
                            <small>
                                Formati accettati: pdf, jpg, png. Massimo 3 file.
                            </small>
                            {fileSizeError && (
                                <small className="text-danger">
                                    File troppo grande. Dimensione massima: 3 MB.
                                </small>
                            )}

                            {attachments.length > 0 ? (
                                <table className="table table-bordered text-center mt-3">
                                    <thead>
                                        <tr>
                                            <th>Nome File</th>
                                            <th>Visualizza</th>
                                            <th>Rimuovi</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {attachments.map((file, index) => (
                                            <tr key={index}>
                                                <td>{file.name}</td>
                                                <td>
                                                    <Button variant="info" onClick={() => this.showAttachment(file)}>
                                                        <i className="fas fa-eye text-white" />
                                                    </Button>
                                                </td>
                                                <td>
                                                    <Button variant="danger" onClick={() => this.removeAttachment(index)}>
                                                        <i className="fas fa-trash-alt text-white" />
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table> ) : (
                                <p className="mt-2">Nessun allegato aggiunto.</p>

                                )}


                        </fieldset>
                    </div>
                </ModalBody>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.closeModal}>
                    Chiudi
                    </Button>
                    <Button variant="primary" onClick={this.confirmCreateTicket} disabled={this.newTicketIsInvalid() || loadingTicket}>
                    {loadingWrapper(loadingTicket, <>Crea</>)}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

const CreateTicketWrapper = (props) => {
    const { createTicket, saveAttachment, loadingTicket } = useTicket();

    return (
        <CreateTicket
            {...props}
            createTicket={createTicket}
            saveAttachment={saveAttachment}
            loadingTicket={loadingTicket}
        />
    );
};

export default CreateTicketWrapper;
